import script from "./TableLite.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./TableLite.vue?vue&type=script&setup=true&lang=ts&generic=T"

import "./TableLite.vue?vue&type=style&index=0&id=f892c908&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f892c908"]])

export default __exports__